// ANY TEXT CHANGE IN THIS FILE (labelConfigs.js) ALSO CROSS CHECKED WITH (msgConfigs.js)
import { userGroupUrlCheck} from '../utils/userGroupUrlCheck';
import {format as stringFormat} from 'react-string-format';
let userGroupData = userGroupUrlCheck(window.location);
let lblCrew = 'Staff'
if(userGroupData!==undefined){
    if(userGroupData.staff_name){
		lblCrew = userGroupData.staff_name; 
	}
}

export const LBL_APP_NAME = "Tascaa"; // CHANGED OMMNI TO TASCAA 18th MARCH 2025

export const LBL_CURRENCY_POUND = "£";

export const LBL_ADD_NEW  = "Add New";
export const LBL_ADDED_BY = 'Added By';
export const LBL_OTHER_AFFILIATES = 'Other Affiliates';

export const LBL_AFFILIATE = "Affiliate";
export const LBL_AFFILIATES = "Affiliates"; 
export const LBL_ADD_AFFILIATE = "Add Affiliate"; 
export const LBL_FOR_AFFILIATES = " for Affiliates"; 

export const LBL_ASSOCIATE = "Associate";
export const LBL_ASSOCIATES = "Associates"; 
export const LBL_ASSOCIATE_USER  = LBL_ASSOCIATE+" User";
export const LBL_ASSOCIATE_USERS = LBL_ASSOCIATE+" Users";

export const LBL_CLIENT = "Client";
export const LBL_CLIENTS = "Clients";
export const LBL_FOR_CLIENTS = " for Clients";
export const LBL_ADD_CLIENT = "Add Client";
export const LBL_ADD_CONTACT = "Add Contact";
export const LBL_ADD_NEW_CLIENT = "Add New Client";
export const LBL_EDIT_CLIENT = "Edit Client";
export const LBL_CLIENT_CONTACT = "Client Contact";
export const LBL_ADD_NEW_CONTACT = "Add New Contact";
export const LBL_ADD_NEW_CLIENT_CONTACT = "Add New Client Contact";

export const LBL_CREW = stringFormat("{0}",lblCrew);  
export const LBL_CREWS = stringFormat("{0}",lblCrew === 'Crew' ? 'Crews':lblCrew);
export const LBL_CREW_LIST = stringFormat("{0} List",lblCrew);
export const LBL_CREW_LIST_APPROVAL_PENDING = stringFormat("{0} List - Approval Pending",lblCrew);
export const LBL_CREW_ADD  = stringFormat("Add {0}",lblCrew);
export const LBL_CREW_EDIT = stringFormat("Edit {0}",lblCrew); 
export const LBL_CREW_CATEGORIES = stringFormat("{0} Categories",lblCrew);
export const LBL_CREW_DOCUMENTS = stringFormat("{0} Documents",lblCrew);  
export const LBL_FOR_CREW = stringFormat("for {0}",lblCrew);  
export const LBL_APPROVAL_PENDING = "Approval Pending";

export const LBL_CREW_SECTIONS = "{0} Sections"; 
export const LBL_CLIENT_SECTIONS = "Client Sections" 
export const LBL_SECTIONS = "Sections"; 

export const LBL_DOC = "Doc";
export const LBL_DOCS = "Docs";

export const LBL_DOCUMENT = "Document";
export const LBL_DOCUMENTS = "Documents";
export const LBL_SKILL_DOCUMENTS = "Skill Documents";
export const LBL_DOCUMENT_NAME = "Document Name";
export const LBL_CLIENT_DOCUMENTS = "Client Documents";

export const LBL_EVENT         	= "Project";
export const LBL_EVENTS 		= "Projects";
export const LBL_ALL_EVENTS 	= "All Projects";
export const LBL_ADD_EVENT 		= "Add Project"; 
export const LBL_EDIT_EVENT 	= "Edit Project";

export const LBL_OTHER_EXPENSE = "Other expense";
export const LBL_OTHER_EXPENSES = "Other expenses";
export const LBL_SHORT_DESCRIPTION = "Short Description";
export const LBL_DESCRIPTION = "Description";

export const LBL_SECTOR = "Sector";
export const LBL_SECTORS = "Sectors"; 

export const LBL_SETTINGS = "Settings";
export const LBL_STAFF_LIST = "Staff List";

export const LBL_SKILL      = "Skill"; 
export const LBL_SKILLS     = "Skills";
export const LBL_ADD_SKILL  = "Add Skill"; 
export const LBL_EDIT_SKILL = "Edit Skill"; 

export const LBL_SUB_SECTOR = "Sub Sector";
export const LBL_SUB_SECTORS = "Sub Sectors";

export const LBL_ROLE = "Role";
export const LBL_ROLES = "Roles";

export const LBL_PERMISSION = "Permission";
export const LBL_PERMISSIONS = "Permissions";
export const LBL_SET_PERMISSIONS = "Set Permissions";

export const LBL_ROLES_AND_PERMISSIONS = "Roles & Permissions";
export const LBL_FULL_ACCESS = "Full Access";

export const LBL_COMPANY_PROFILE = "Company Profile";
export const LBL_MY_PROFILE      = "My Profile";

export const LBL_LOCATION = " Location";
export const LBL_LOCATIONS = "Locations";
export const LBL_EVENT_LOCATIONS = (LBL_EVENT+" Locations");

export const LBL_KEY_LOCATION = "Key Location"; 
export const LBL_KEY_LOCATIONS = "Key Locations";

export const LBL_DEPARTMENT = "Department";
export const LBL_DEPARTMENTS = "Departments";
export const LBL_DEPARTMENT_ALL_SHIFTS = "Apply to all shifts, If dept not set.";

export const LBL_PROFILE = "Profile";
export const LBL_PROFILES = "Profiles";

export const LBL_STC_BONUS = 'Short Term Call Bonus'; 
export const LBL_BTN_ADD_STC = 'Add Short Term Call Bonus'; 

export const LBL_FRIEND = "Friend";
export const LBL_FRIENDS = "Friends";

export const LBL_DYNAMIC_FIELDS_AFFILIATES = "Dynamic Fields for Affiliates";
export const LBL_DYNAMIC_FIELDS_CLIENTS = "Dynamic Fields for Clients";
export const LBL_DYNAMIC_FIELDS_CREW = stringFormat('Dynamic Fields for {0}',lblCrew); 
export const LBL_TRAVEL_MODULE_FIELDS_AFFILIATES = "Travel Module Fields for Affiliates";
export const LBL_TM_FIELD_NAME 		= "Field Name";
export const LBL_TM_FIELD_CALC 		= "Calculation Based On";
export const LBL_TM_CALC_METHOD 	= "Calculation Method";

export const LBL_DYNAMIC = "Dynamic";
export const LBL_FIELD  = "Field";
export const LBL_FIELDS = "Fields";

export const LBL_BTN_ADDNEW  = "Add New";

export const LBL_DASHBOARD  = "Dashboard";

export const LBL_APPAYRATE_ADD  = "Add AP Pay Rate"; 
export const LBL_APPAYRATE_EDIT = "Edit AP Pay Rate"; 
export const LBL_APPAYRATE  = "AP Pay Rate"; 

export const LBL_SLNUM = '#'; 

export const LBL_POINT = "Point";
export const LBL_POINTS = "Points";

export const LBL_MASTER_RATE_CARD = "Master Rate Card";
export const LBL_RATE_CARD = "Rate Card";
export const LBL_RATE_CARDS = "Rate Cards";

export const LBL_PAY_RATE       = "Pay Rate";
export const LBL_PAY_RATES      = "Pay Rates";

export const LBL_CHARGE_RATE    = "Charge Rate";
export const LBL_CHARGE_RATES   = "Charge Rates";

export const LBL_HOUR       = "Hour";
export const LBL_HOURS      = "Hours";
export const LBL_HOUR_SHORT = "Hr";
export const LBL_HOURS_SHORT= "Hrs"; 
export const LBL_MINUTE     = "Minute";
export const LBL_MINUTES    = "Minutes";
export const LBL_MIN_SHORT  = "Min";
export const LBL_MINS_SHORT = "Mins";
export const LBL_TIME_HRS_MINS= "Hrs:Mins"; 



export const LBL_STAFF_PER_VEHICLE  = "Staff per vehicle";
export const LBL_NO_OF_VEHICLES = "No of Vehicles";

export const LBL_FIELD_NAME   = "Field Name";
export const LBL_FIELD_TYPE   = "Field Type";
export const LBL_FIELD_MANDATORY  = "Mandatory Field?";
export const LBL_MANDATORY    = "Mandatory";

export const LBL_CATEGORY           = 'Category'; 
export const LBL_CATEGORIES         = 'Categories'; 

export const LBL_CLIENT_CATEGORY    = 'Client Category'; 
export const LBL_CLIENT_CATEGORIES  = 'Client Categories'; 

export const LBL_SHOW_THIS_TAB  = ' Show this tab '; // USED IN DYNAMIC FIELDS CONPONENTS 
export const LBL_MANDATORY_FIELD  = 'Mandatory Field?'; // USED IN DYNAMIC FIELDS CONPONENTS 

export const LBL_ACTIONS  = 'Actions';
export const LBL_ACTION   = 'Action';

export const LBL_QUOTES = "Quotes"; 
export const LBL_QUOTE = "Quote"; 
export const LBL_EDIT_QUOTE = "Edit Quote"; 

export const LBL_NOTIFICATION = 'Notification'; 
export const LBL_NOTIFICATIONS = 'Notifications'; 
export const LBL_YOUR_NOTIFICATIONS = 'Your Notifications'; 

export const LBL_VAT            = 'VAT'; 
export const LBL_DISCOUNT       = 'Discount'; 
export const LBL_SUMMARY        = 'Summary'; 
export const LBL_EDIT_DISCOUNT  = 'Add Discount'; 
export const LBL_DISC_PERCENTAGE= 'Discount %'; 
export const LBL_DISCOUNT_AMOUNT  	= 'Amount'; 
export const LBL_DISCOUNT_PERCENTAGE= 'Percentage'; 

export const LBL_VENUE = 'Venue'; 
export const LBL_VENUE_PROFILE = 'Building'; 
export const LBL_SHIFT = 'Shift';
export const LBL_SHIFTS = 'Shifts';
export const LBL_SHIFT_LENGTH = 'Shift length';
export const LBL_CONFIRM_CANCEL_SHIFT_HEAD = 'Confirm Cancel Shift ';

export const LBL_CHIEF  = 'Chief'; 
export const LBL_CHIEFS = 'Chiefs';

export const LBL_CREW_CHIEF  = 'Crew Chief';
export const LBL_CREW_CHIEFS = 'Crew Chiefs';
export const LBL_NO_CHIEFS = 'No Crew Chiefs'; 

export const LBL_EVENT_PREFIX  = '#E-'; 
export const LBL_SHIFT_PREFIX  = '#S-'; 
export const LBL_SHIFT_SEQ_PREFIX = '#'; 

export const LBL_SHIFT_TITLE_SEPARATOR = ' @ '; 
export const LBL_CONTACT_PERSON = 'Contact Person'; 
export const LBL_CONTACT = 'Contact'; 

export const LBL_LOG  = 'Log'; 
export const LBL_LOGS = "Logs"; 

export const LBL_CREW_REQUIRED = 'Required'; 
export const LBL_CREW_REQUESTED= 'Requested'; 
export const LBL_CREW_PENDING  = 'Pending'; 
export const LBL_CREW_ASSIGNED = 'Assigned';
export const LBL_CREW_ACCEPTED = 'Accepted';
export const LBL_CREW_REJECTED = 'Rejected'; 
export const LBL_CREW_ACCEPT   = 'Accept';
export const LBL_CREW_REJECT   = 'Reject'; 
export const LBL_CREW_CHECKIN  = 'Checkin'; 
export const LBL_CREW_CHECKOUT = 'Checkout'; 
export const LBL_CREW_COMPLETED= 'Completed'; 
export const LBL_CREW_CANCELLED= 'Cancelled';
export const LBL_CREW_NOT_CHECKED_IN= 'Not Checked-in';
export const LBL_CREW_ABSENT= 'Absent';

export const LBL_SCHEDULE_CALENDAR    = 'Schedule Calendar'; 
export const LBL_SCHEDULE_SHIFT = "Schedule ";
export const LBL_GENERATE_INVOICE = "Generate Invoice";
export const LBL_SCHEDULE_SHIFT_CALENDAR = "Schedule Calendar";
export const LBL_SCHEDULE_STATUS = "Schedule Status ";
export const LBL_SCHEDULE_CREW_STATUS = stringFormat("Schedule {0} Status ",lblCrew);


export const LBL_MEMBER  = "Member";
export const LBL_MEMBERS = "Members";

export const LBL_PO = 'PO #';  // Purchase Order Number

export const LBL_PURCHASE_ORDER = 'Purchase Order';

export const LBL_AFLT_MANAGER = LBL_AFFILIATE+' Manager';

export const LBL_TIMESHEET = 'Timesheet'; 
export const LBL_TIMESHEET_OF = 'Timesheet of'; 

export const LBL_SCHEDULE = "Schedule";
export const LBL_SCHEDULES = "Schedules";

export const LBL_FEEDBACK = 'Feedback';

export const LBL_TIME_ZONE = 'Time Zone'; 
export const LBL_EMAIL_FUNCTIONALITY = 'BLOCK ALL EMAILS SENDING FROM '+LBL_APP_NAME; 
export const LBL_ISSUE_DATE = 'Issue Date'; 
export const LBL_MODIFIED_DATE = 'Modified Date'; 
export const LBL_QUOTE_VALID_UNTIL = LBL_QUOTE+' Valid Until'; 
export const LBL_UNAVAILABILITY = 'Unavailability';
export const LBL_CREW_UNAVAILABILITY = stringFormat('{0} Unavailability',lblCrew);
export const LBL_ADD_UNAVAILABILITY = 'Add Unavailability';
export const LBL_EDIT_UNAVAILABILITY = 'Edit Unavailability';
export const LBL_TITLE = 'Title'; 

export const LBL_ADD = 'Add'; 
export const LBL_EDIT = 'Edit'; 
export const LBL_DELETE = 'Delete';  
export const LBL_UNDO_DELETE = 'Undo Delete'; 
export const LBL_MODIFY = 'Modify'; 

export const LBL_CLEAR_FILTERS = 'Reset Filter'; 
export const LBL_CLEAR = 'Clear'; 

export const LBL_SELECT     = 'Select';  
export const LBL_NOTES      = 'Notes'; 
export const LBL_ACTIVATE   = 'Activate'; 
export const LBL_DEACTIVATE = 'Deactivate'; 
export const LBL_DEACTIVATED= 'Deactivated'; 
export const LBL_SAVE       = 'Save'; 
export const LBL_SAVE_AND_CONTINUE       = 'Save & Continue'; 
export const LBL_FINISH_QUOTE       = 'Finish Quote'; 
export const LBL_DOWNLOAD   = 'Download'; 
export const LBL_DOWNLOAD_SUMMARY   = 'Download Timesheet Summary'; 
export const LBL_DOWNLOAD_DETAILS   = 'Download Timesheet Details'; 
export const LBL_INVICE_EXPORT   = 'Export Invoices'; 
export const LBL_TEMPLATE_NAME   = 'Template Name'; 
export const LBL_TEMPLATE_SAMPLE = 'Template Sample'; 
export const LBL_CSV_TEMPLATES_DOWNLOAD = 'CSV Templates to Import'; 
export const LBL_CSV_DOWNLOAD_HEADING = 'CSV Templates for importing bulk data'; 

export const LBL_QTY = 'Qty'; 
export const LBL_CHARGE_RATES_HR = 'Charge rates/hr'; 
export const LBL_CHARGE_RATES_CREW = stringFormat('Charge rates/{0}',lblCrew); 

export const LBL_TOTAL    = 'Total'; 
export const LBL_SKILL_TOTAL    = 'Skill Total'; 
export const LBL_SUB_TOTAL= 'Sub total'; 

export const LBL_REQUEST  = 'Request'; 
export const LBL_ACCEPT   = 'Accept';
export const LBL_REJECT   = 'Reject'; 
export const LBL_SEND_TO  = 'Send to';  

export const LBL_BANK_ACC_DET = 'Bank Account Details'; 

export const LBL_SAME_LOC_AS_EVENT = 'Same location as event'; 
export const LBL_LOC_GET_GOOGLE = "Couldn't find the location? Get it from Google"; 
export const LBL_VENUE_NAME = 'Venue Name'; 
export const LBL_STREET_1   = 'Street 1'; 
export const LBL_STREET_2   = 'Street 2'; 
export const LBL_CITY       = 'City'; 
export const LBL_STATE      = 'State'; 
export const LBL_COUNTRY    = 'Country'; 
export const LBL_POST_CODE  = 'Post code'; 

export const LBL_IS_REPEATING_SHIFT = 'Is this a repeating shift?'; 

export const LBL_START_DATE_TIME    = 'Start date and time'; 
export const LBL_END_DATE_TIME      = 'End date and time'; 
export const LBL_START_TIME         = 'Start time'; 
export const LBL_END_TIME           = 'End time'; 
export const LBL_DATES              = 'Dates'; 
export const LBL_SHIFT_REPEATS_ON   = 'Shift repeats on'; 
export const LBL_AFFILIATE_MANAGER  = 'Affiliate Manager'; 
export const LBL_CONTACT_FROM_CLIENT= "Shift Contact (Client)"; 
export const LBL_SKILLS_REQ_CREW_COUNT = stringFormat('Skills / Required {0} Count / Chief Count',lblCrew); 

export const LBL_FILTER         = 'Filter'; 
export const LBL_ACTION_NEEDED  = 'Action Needed'; 
export const LBL_LIST_ALL       = 'List All'; 

export const LBL_PERSON               = 'Person'; 
export const LBL_EVENT_TITLE          = 'Project Title'; 
export const LBL_START_CHECKIN_TIME   = 'Start/Checkin Time'; 
export const LBL_END_CHECKOUT_TIME    = 'End/Checkout Time'; 
export const LBL_CREW_PAY             = stringFormat('{0} Pay',lblCrew); 
export const LBL_SCHEDULED_HRS        = 'Scheduled hrs'; 
export const LBL_ACTUAL_HRS           = 'Actual hrs'; 
export const LBL_OT_HRS               = 'OT hrs'; 
export const LBL_APPROVAL_STATUS      = 'OT Approval status'; 

export const LBL_VIEW_MORE            = 'View more'; 

export const LBL_STATUS               = 'Status'; 
export const LBL_EVENT_STATUS         = LBL_EVENT+' Status'; 
export const LBL_QUOTE_STATUS         = 'Quote Status'; 

export const LBL_AP_CATEGORY          = 'AP Category'; 
export const LBL_AP_FROM              = 'AP from'; 
export const LBL_AP_TO                = 'AP to'; 
export const LBL_RATE                 = "Rate"; 

export const LBL_COMPANY_INFO         = "Company Info"; 
export const LBL_COMPANY_NAME         = "Company Name"; 
export const LBL_COMPANY_CONTACT_NUM  = "Company contact number"; 
export const LBL_COMPANY_REG_NUM      = "Company registration number"; 
export const LBL_COMPANY_EMAIL        = "Company email address"; 
export const LBL_WEBSITE              = "Website"; 
export const LBL_VAT_NUMBER           = "VAT Number"; 
export const LBL_VAT_TAX              = "VAT tax(%)"; 

export const LBL_DISTANCE_UNIT          = "Distance Unit"; 
export const LBL_MILES                  = "Miles"; 
export const LBL_KM                     = "KM"; 
export const LBL_CURRENCY               = "Currency"; 
export const LBL_QUOTE_VALIDITY         = "Quote Validity"; 
export const LBL_CREW_COUNT_FOR_CHIEF   = stringFormat("{0} count for assigning one",lblCrew)+" {0}"; 
export const LBL_MIN_DIST_TRAVEL_CHARGES= "Min distance without travel charges"; 
export const LBL_TRAVEL_EXPENSE_RATE    = "Travel Expense Rate"; 
export const LBL_SELECT_TIME_ZONE       = "Select Time Zone"; 
export const LBL_INVOICE                = 'Invoice'; 
export const LBL_COMMISSION_FOR_APP     = 'Commission for using the app (%)'; 
export const LBL_COMMISSION_FOR_OMNU    = 'Commission for using the '+LBL_APP_NAME+' Pool (%)'; 
export const LBL_ADDITIONAL_TEXT_PAY    = 'Additional text related to payments, if any'; 
export const LBL_MUTE_ALL_CLIENT_EMAILS = 'Mute all emails to clients';
export const LBL_30_DAYS                = '30 Days'; 
export const LBL_CHIEF_PAY_RATE         = "{0} Pay Rate (Bonus)/hr"; 
export const LBL_CHIEF_CHARGE_RATE      = "{0} Charge Rate/hr "; 
export const LBL_CREW_CHECKIN_ALLOWED_TIME = stringFormat("{0} check-in allowed before (hh:mm, before shift start time)",lblCrew); 
export const LBL_CREW_ALLOWED_TIME_TO_UPDATE_TIMESHEET = stringFormat("{0} can send OT/OE requests for (hh:mm, after checkout)",lblCrew); 
export const LBL_MIN_SHIFT_LENGTH       = "Minimum shift length (hh:mm)"; 
export const LBL_TRAVEL_TIME_ROUND_OFF  = "Travel time round off (hh:mm)"; 
export const LBL_TRAVEL_MODULE 			= 'Travel Cost';
export const LBL_TRAVEL_COST 			= 'Travel Cost';
export const LBL_RETURN_COST_INCLUDED 	= '( Return Covered )';
export const LBL_TOTAL_TRAVEL_COST		= 'Total Travel Cost';
export const LBL_ADD_TRAVEL_MODULE 		= 'Include Travel Cost';
export const LBL_TM_INCLUDE_RETURN_COST	= 'Include Return Cost ';

export const LBL_TRAVEL_MODULE_ACTIVATE	= 'Activate Travel Cost';
export const LBL_TRAVEL_MODULE_FIELDS_CHOOSE = 'Choose Travel Module Fields';
export const LBL_TM_MIN_TRAVEL_DIST     = 'Minimum Travel Distance'; // TM - TRAVEL MODULE 
export const LBL_TM_MIN_TRAVEL_DISTANCE = 'Min. distance to calculate travel cost (in miles)'; 
export const LBL_CHOOSE_TRAVEL_FIELDS   =  'Choose fields for travel cost (charge rate and pay rate) calculations';
export const LBL_DEFAULT_VALUE			= 'Default Rate'; 
export const LBL_TRAVEL_TIME 			= 'Travel Time';
export const LBL_DISTANCE   			= 'Distance';
export const LBL_DISTANCE_TO_LOCATION   = 'Distance to location';
export const LBL_TM_STAFF_PER_VEHICLE_DEFAULT   = stringFormat('{0} per vehicle (for travel cost calculation)',lblCrew); // TM - TRAVEL MODULE 
export const LBL_TRAVEL_COST_TOTAL		= 'Total Travel Cost';
export const LBL_MIN_DIST_EXCEEDED		= 'Minimum travel distance exceeded, travel costs included';  
export const LBL_NUM_PASSENGERS			= 'No. of Passengers';


export const LBL_TM_STAFF_PER_VEHICLE   = stringFormat('{0} per vehicle',lblCrew); // TM - TRAVEL MODULE 
export const LBL_TM_NUM_OF_VEHICLE      = "Num. of Vehicles"; 
export const LBL_TM_TOTAL      			= "Total"; 
export const LBL_TM_ACTION     			= "Action";  

export const LBL_REVIEWED_BY            = "Reviewed by"; 

export const LBL_DATE_FROM              = "Date From";  
export const LBL_DATE_TO                = "Date To"; 

export const LBL_SELECT_EVENTS          = ("Select "+LBL_EVENTS); 

export const LBL_SHIFT_DATE             = "Shift Date"; 
export const LBL_COMPLETED_SHIFT_CREWS  = stringFormat("Completed Shifts & {0}",lblCrew); 
export const LBL_RATING                 = "Rating"; 
export const LBL_REVIEW_COMMENTS        = "Review Comments"; 
export const LBL_REVIEW                 = "Review"; 
export const LBL_SHIFT_DATE_FROM        = "Shift Date From"; 

export const LBL_LOGOUT  = 'Logout'; 

export const LBL_CREATED_DATE_TIME      = "Created Date & Time"; 
export const LBL_NAME                   = "Name"; 
export const LBL_EMAIL                  = "Email"; 
export const LBL_PHONE                  = "Phone"; 
export const LBL_LAST_LOGIN             = "Last Login"; 

export const LBL_FIRST_NAME             = "First Name"; 
export const LBL_LAST_NAME              = "Last Name"; 
export const LBL_PREFERED_NAME          = "Prefered Name"; 
export const LBL_MOBILE_NUMBER          = "Mobile Number"; 
export const LBL_EMAIL_ADDRESS          = "Email Address"; 
export const LBL_SEND_VERIFI_EMAIL      = "Send verification email"; 
export const LBL_RESEND_VERIFI_EMAIL    = "Resend verification email"; 
export const LBL_RESEND_EMAIL    		= "Resend email"; 

export const LBL_SELECT_ROLE            = "Select Role"; 
export const LBL_POSITION               = "Position"; 
export const LBL_ACTIVE                 = "Active"; 
export const LBL_SUSPENDED              = "Suspended"; 
export const LBL_SELECT_STATUS          = "Select Status"; 
export const LBL_USER_CREATED_ON        = "User Created On"; 
export const LBL_LAST_LOGGED_IN         = "Last Logged In";
export const LBL_HAS_VEHICLE         	= "Has Vehicle";


export const LBL_INVITE_A_FRIEND        = "Invite"; 
export const LBL_RECIPIENT_NAME         = "Recipient Name"; 
export const LBL_RECIPIENT_EMAIL        = "Recipient email address"; 
export const LBL_INVITE_AS              = "Invite As"; 
export const LBL_CREW_MEMBER            = lblCrew; // stringFormat("{0} Member",lblCrew);   
export const LBL_SEND_INVITE            = "Send Invite";   

export const LBL_CHANGE_PASSWORD        = "Change Password";   
export const LBL_STAR                   = 'Star'; 
export const LBL_LOGIN_AS_THIS_USER     = 'Login as this user'; 
export const LBL_LOGIN_AS               = 'Login as'; 

export const LBL_CERTIFICATE            = "Certificate";
export const LBL_CERTIFICATES           = "Certificates";
export const LBL_EXPIRING_CERTIFICATES  = "Expiring Certificates";
export const LBL_EXPIRED_CERTIFICATES   = "Expired Certificates";

export const LBL_START_DATE             = 'Start Date'; 
export const LBL_END_DATE               = 'End Date'; 
export const LBL_DAYS_PENDING           = 'Days Pending'; 
export const LBL_DAYS_EXCEEDED          = 'Days Exceeded'; 
export const LBL_VERIFIED               = 'Verified'; 
export const LBL_NOT_VERIFIED           = 'Not verified'; 
export const LBL_PROJECT_DURATION       = 'Project Duration'; 
export const LBL_PROJECT_DATE        	= 'Project Date'; 

export const LBL_PAY_LEVEL              = "Pay Level";
export const LBL_PAY_LEVELS             = "Pay Levels";
export const LBL_OMNU_POINTS_AGAINST_PP = LBL_APP_NAME+" Points against PP";
export const LBL_OMNU_POINTS_AGAINST_PP_TITLE  = LBL_APP_NAME+" Points against Performance Points";

export const LBL_PP_POINTS = "Performance Points";

export const LBL_FOR = "For";
export const LBL_HRS_ABOVE = "hrs and above";
export const LBL_CONFIRM_DELETE_ROW = "Are you sure you want to delete this row?"; 
export const LBL_REMOVE_ROW = "Remove this Row";

export const LBL_SUBMIT             = 'Submit'; 
export const LBL_LOGIN_SA           = 'S.A. Login'; 
export const LBL_LOGIN_AFFILIATE    = 'Affiliate Login'; 
export const LBL_LOGIN_CLIENT       = 'Client Login'; 
export const LBL_USERNAME           = 'Username'; 
export const LBL_PASSWORD           = 'Password'; 
export const LBL_FORGOT_PASSWORD    = 'Forgot Password ?'; 
export const LBL_LOGIN              = 'Login';   
export const LBL_BACK_TO_LOGIN      = 'Bacl to Login'; 
export const LBL_CLOSE              = 'Close'; 
export const LBL_REMEBER_ME         = 'Remember Me'; 

export const LBL_AFFILIATE_NAME     = 'Affiliate Name';   
export const LBL_CONTACT_NUMBER     = 'Contact Number';   
export const LBL_CREATED_DATE       = 'Created Date';   

export const LBL_DATE_OF_JOIN       = 'Date of join';   
export const LBL_AVAILABILITY       = 'Availability';
export const LBL_AVAILABLE_Q        = 'Available?';
export const LBL_APPROVED           = 'Approved'; 
export const LBL_APPROVED_Q           = 'Approved?'; 
export const LBL_CROP               = 'Crop';

export const LBL_TYPE_ADDRESS_GOOGLE= 'Type address to get the location from Google map';   
export const LBL_TYPE_A_LOCATION    = 'Type a location...';   
export const LBL_SEARCHING          = 'Searching';   

export const LBL_QUICK_ADD          = 'Quick Add';   
export const LBL_CSV_IMPORT         = 'CSV Import';  
export const LBL_CSV_EXPORT         = 'CSV Export';   
export const LBL_CSV_IMPORT_QUICKFILE = 'CSV Client import from Quickfile with limited fields';  


export const LBL_EVENT_START_DATE_FROM = (LBL_EVENT+' Start Date From');  
export const LBL_SEE_ALL            = 'See all';  

export const LBL_CREW_NAME          = stringFormat('{0} Name',lblCrew); 

export const LBL_YES                = 'Yes'; 
export const LBL_NO                 = 'No'; 
export const LBL_CANCEL             = 'Cancel'; 
export const LBL_DECLINE            = 'Cancel/Decline'; 
export const LBL_UPDATE_QUOTE       = 'Update Quote'; 
export const LBL_APPROVE            = 'Approve';  
export const LBL_SAVE_AND_NEW       = 'Save & New';   
export const LBL_ADD_ANOTHER_SHIFT  = 'Add another shift';     
export const LBL_APPROVE_OT         = 'Approve OT';
export const LBL_MARK_ABSENT        = 'Mark Absent';

export const LBL_CHECKIN_FROM_TIME  = 'Checkin From time';  
export const LBL_FROM_TIME          = 'From time';  
export const LBL_TO_TIME            = 'To time';    
export const LBL_CHECKOUT_FROM_TIME = 'Checkout From time';    
export const LBL_SCHEDULED_HOURS    = 'Scheduled hrs';    
export const LBL_ACTUAL_HOURS       = 'Actual hrs';    
export const LBL_OT_HOURS           = 'OT hrs';   
export const LBL_SELECT_HOURS       = 'Scheduled / OT hrs'; // 'Actual /' COMMENTED ON 18 March 2021 ON CUSTOMER REQUEST  
export const LBL_CHECKIN_CHECKOUT   = 'Checkin / Checkout';  
export const LBL_CHECKIN            = 'Checkin'; 
export const LBL_CHECKOUT           = 'Checkout';  

export const LBL_BASIC_INFO         = 'Basic Info';  
export const LBL_CREW_INDUCTION_COMPLETED_Q = stringFormat('Are you sure this {0} is completed the induction?',lblCrew);  
export const LBL_VERIFY_CREW_DOCUMENTS_Q = stringFormat('Did you verify all the documents? Are you sure you want to approve this {0}?',lblCrew);  
export const LBL_VERIFY_CREW_CHIEF_Q    = stringFormat('Are you sure this {0}',lblCrew)+' is eligible for {0} role?';
export const LBL_VERIFY_CREW_CHIEF_NO_Q = stringFormat('Are you sure this {0}',lblCrew)+' is not eligible for {0} role?';

export const LBL_COMPLETED_DATE           = 'Completed Date';  
export const LBL_STARTED_DATE             = 'Started Date';  
export const LBL_CREATED_COMPLETED_DATE   = (LBL_EVENT+' Created / Started / Completed Date');  
export const LBL_EVENT_STAFF_ASSIGNED_STATUS  = (LBL_EVENT+' Staff Assigned Status');  

export const LBL_IF_THERE_IS_A_CERTIFICATION='** if there is a certification related to your skill, please upload that in documents tab.';  
export const LBL_YEARS              = 'Years';  
export const LBL_MONTHS             = 'Months';  
export const LBL_REMOVE_THIS_ROW    = 'Remove this Row ';  
export const LBL_ARE_YOU_SURE_DELETE_SKILL = 'Are you sure you want to delete the skill ';  
export const LBL_FROM_CREW_MEMBER   = stringFormat('from {0} member ',lblCrew);  

export const LBL_SEARCH          = 'Search';   
export const LBL_CHIEF_S         = 'Chief (s)';   
export const LBL_REVIEWEE        = 'Reviewee';   
export const LBL_CHIEF_NOT_AVAIL = '{0} not available';   
export const LBL_RATING_REVIEW   = 'Rating & Review';   

export const LBL_DATE_VIEW       = 'Date View';   
export const LBL_CREW_VIEW       = stringFormat('{0} View',lblCrew);   
export const LBL_REQUIRED        = 'Required'; 
export const LBL_REQUESTED       = 'Requested'; 
export const LBL_PENDING         = 'Pending'; 
export const LBL_ON              = 'on'; 
export const LBL_CONFIRMED       = 'Confirmed'; 

export const LBL_SHIFT_NAME      = 'Shift Name'; 
export const LBL_SHIFT_TIME      = 'Shift Time';  
export const LBL_CREW_CHIEF_S    = 'Crew Chief(s)'; 
export const LBL_SHIFT_STATUS    = 'Shift Status'; 
export const LBL_TEAM_COUNT      = 'Team Count'; 
export const LBL_CREW_CHIEF_BONUS= 'Crew Chief Bonus'; 
export const LBL_SHIFT_TITLE     = 'Shift Title'; 
export const LBL_SHIFT_TOTAL     = 'Shift Total'; 


export const LBL_CONFIRM_DELETE_SHIFT = 'Are you sure you want to delete the shift '; 
export const LBL_CONFIRM_CANCEL_SHIFT = 'Are you sure you want to cancel this shift? This action cannot be undone. ';                                       

export const LBL_QUOTE_SUMMARY      = "Quote Summary"; 
export const LBL_EVENT_SUMMARY      = (LBL_EVENT+" Summary"); 
export const LBL_CLIENT_DETAILS     = "Client Details"; 
export const LBL_AFFILIATE_DETAILS  = "Affiliate Details"; 
export const LBL_PREVIEW_QUOTE      = "Preview Quote"; 
export const LBL_SEND_QUOTE         = "Send Quote"; 
export const LBL_SEND_INVOICE       = "Send Invoice";
export const LBL_RESEND_INVOICE     = "Resend Invoice";
export const LBL_EXPORT_INVOICE     = "Export Invoice";
export const LBL_ACCEPT_QUOTE       = "Accept Quote"; 
export const LBL_REQUEST_QUOTE      = "Request Quote"; 
export const LBL_REJECT_QUOTE       = "Reject Quote"; 
export const LBL_ADD_SHIFT          = "Add shift";  
export const LBL_FROM               = 'From'; 
export const LBL_TO                 = 'To'; 
export const LBL_OFFICE_CONTACT     = 'Office Contact'; 
export const LBL_GRAND_TOTAL        = 'Grand Total'; 
export const LBL_MEMBERS_REQUIRED   ='Members Required'; 
export const LBL_ACCEPTED           = 'Accepted';
export const LBL_DUPLICATE          = 'Duplicate';

export const LBL_FILTER_BY          = 'Filter By';
export const LBL_RESET              = 'Reset';
export const LBL_APPLY              = 'Apply';

export const LBL_ALL                = 'All';
export const LBL_NON_CHIEF          = 'Non Crew Chief';
export const LBL_COMPLETED          = 'Completed'; 
export const LBL_INCOMPLETE         = 'Incomplete';
export const LBL_AVAILABLE          = 'Available';
export const LBL_UNAVAILABLE        = 'Unavailable';
export const LBL_CREW_UNAVAILABLE_PART= stringFormat('Shift time change - Some {0} are unavailable',lblCrew.toLowerCase());
export const LBL_CREW_UNAVAILABLE_ALL = stringFormat('Shift time change - All {0} are unavailable',lblCrew.toLowerCase());
export const LBL_BTN_ACCEPT_UNAVAILABLE_PART = stringFormat('Send new request to available {0} & Go to Schedule',lblCrew.toLowerCase()); 
export const LBL_BTN_ACCEPT_UNAVAILABLE_ALL  = stringFormat('Remove unavailable {0} & Go to Schedule',lblCrew.toLowerCase()); 

export const LBL_INACTIVE           = 'Inactive';
export const LBL_INDUCTION          = 'Induction';  
export const LBL_APPROVAL           = 'Approval';
export const LBL_SHOW_UNAPPROVED_CREW = stringFormat('{0}(s) - Approval Pending',lblCrew);
export const LBL_ARE_YOU_SURE_DELETE_CREW = stringFormat('Are you sure you want to delete the {0} member ',lblCrew);  
export const LBL_ARE_YOU_SURE_DELETE_COMMON = 'Are you sure you want to delete {0}? ';  
export const LBL_ARE_YOU_SURE_DELETE_OTHEXP = 'Are you sure you want to delete  other expense {0}? ';  

// ************* VALIDATION LABELS - START ***********
export const LBL_VAL_CLADD_COMM_ERR = 'Client cannot be added due to missing mandatory data.'; 
export const LBL_VAL_CLADD_RATECARD = '* Master rate card values are mandatory to add a client. Please update it from the settings.'; 

export const LBL_VAL_CLDET_COMM_ERR = 'Client details cannot be added due to missing mandatory data.'; 
export const LBL_VAL_CLDET_HEADER   = 'The following fields are mandatory.'; 
export const LBL_PRIMARY_CONTACT    = 'Primary Contact'; 
export const LBL_PRIMARY    = 'Primary'; 
export const LBL_BANK_DETAILS       = 'Bank Details'; 
export const LBL_ADDITIONAL_INFO    = 'Additional Info'; 

export const LBL_VAL_EVADD_COMM_ERR = (LBL_EVENT+' cannot be added due to missing mandatory data.'); 
export const LBL_VAL_EVADD_HEADER   = 'The following values are mandatory to create an event. Please update them from the settings.'; 

export const LBL_VAL_CREWADD_COMM_ERR = stringFormat('{0} cannot be added due to missing mandatory data.',lblCrew); 
export const LBL_VAL_CREWADD_HEADER   = stringFormat('The following details are mandatory to create a {0}. Please update them from the settings.',lblCrew);

export const LBL_VAL_CREWDET_COMM_ERR = stringFormat('{0} details cannot be added due to missing mandatory data.',lblCrew); 
export const LBL_VAL_CREWDET_HEADER   = stringFormat('The following criteria are mandatory to list the {0} for scheduling. ',lblCrew);

export const LBL_HEALTH_INFO          = 'Health Info'; 
export const LBL_INDUCTION_MUST_COMPLETED  = 'Induction must be completed'; 
export const LBL_APPRVD_BY_AFFILIATE  = 'Approved by affiliate'; 
export const LBL_EMAIL_MUST_VERIFIED  = 'Email must be verified.'; 
export const LBL_AVAILABLE_FOR_SCHEDULE='Availability status should be ON'; 

export const LBL_USER_ACTION_LOGS     = 'User Action Logs'; 

export const LBL_SEARCH_CREW_NAME     = stringFormat('Search {0} name...',lblCrew); 

export const LBL_CONFIRM_ACTIVATE_CREW= stringFormat("Are you sure you want to activate the {0} member ",lblCrew); 
export const LBL_CONFIRM_DEACTIVATE_CREW=stringFormat("Are you sure you want to deactivate the {0} member ",lblCrew);
export const LBL_CONFIRM_ACTIVATION   = "Confirm Activation"; 
export const LBL_CONFIRM_DEACTIVATION = "Confirm Deactivation"; 
export const LBL_CONFIRM_DELETION     = "Confirm Deletion"; 
export const LBL_CONFIRM_CATEGORY_CHANGE     = "Confirm Category Change"; 

export const LBL_CONFIRM_EVENT_COMPLETE = "Are you sure you want to update status of this event to 'Completed'? " +stringFormat("This action will forcefully checkout all the {0} members and the shifts will be marked as completed.",lblCrew); 
export const LBL_COMPLETE               = 'Complete'; 
export const LBL_AUTO                   = 'AUTO'; 

export const LBL_ACTIVE_SHIFTS          = 'Active Shifts'; 
export const LBL_AFFILIATE_POOL         = 'Affiliate Pool'; 
export const LBL_OMNU_POOL              = LBL_APP_NAME+' Pool'; 

export const LBL_SHIFT_COUNT            = 'Shift Count'; 
export const LBL_Total_COST             = 'Total Cost'; 
export const LBL_QUOTE_NO               = "Quote No"; 

export const LBL_LIST_VIEW              = "List View"; 
export const LBL_CALENDAR_VIEW          = "Calendar View"; 

export const LBL_PAY_LEVEL_NAME         = "Pay Level Name";
export const LBL_PAY_RATE_BONUS         = "Pay Rate Bonus";
export const LBL_PAY_LEVEL_ADD          = "Add Pay Level";
export const LBL_PAY_LEVEL_EDIT         = "Edit Pay Level";

export const LBL_FILE                   = "File";

export const LBL_PP_FROM                 = "PP From";
export const LBL_PP_TO                   = "PP To";
export const LBL_PP_UPTO                 = "PP Up To";
export const LBL_OMNU_POINTS             = "Tascaa Points";

export const LBL_SELECT_CONTACT          = "Select Contact"; 
export const LBL_REQ_CREW_COUNT          = stringFormat('Required {0} Count',lblCrew);
export const LBL_CHIEF_COUNT             = 'Chief Count';
export const LBL_TOT_NUM_RESOURCES       = 'Total no of resources';
export const LBL_OTHER_EXPENSES_COST     = "Other Expenses & Cost";
export const LBL_SHIFT_NOTES             = "Shift Notes";
export const LBL_CHOOSE_A_CONTACT        = "Choose a contact...";
export const LBL_MAX_SUGGESTED           = "Max Suggested";

export const LBL_CONTACT_DETAILS         = 'Contact Details';  
export const LBL_PROJECT_DETAILS         = 'Project Details';  
export const LBL_PROJECT_NAME            = 'Project Name';  
export const LBL_START_DATE_AND_TIME     = 'Start Date';  
export const LBL_END_DATE_AND_TIME       = 'End Date';  
export const LBL_VENUE_AND_ADDRESS       = 'Venue & Address';  
export const LBL_SUBMIT_MSG_FOR_QUOTE    = 'You have submitted  the quote successfully a confirmation code has been generated';  

export const LBL_CONFIRM_DELETE_CONTACT  = 'Are you sure you want to delete the Contact?';  

export const LBL_PROFILE_NAME            = 'Profile Name';  

export const LBL_UNREAD                  = 'Unread';  
export const LBL_MARK_AS_READ            = 'Mark as Read';  
export const LBL_MARK_ALL_AS_READ        = 'Mark all as read'; 

export const LBL_CONFIRM_DELETE_PAY_LEVEL = "Are you sure you want to delete PP Up To "; 

export const LBL_CONFIRM_DELETE_ASSOC_USER = "Are you sure you want to delete user "; 
export const LBL_CONFIRM_UNDO_DELETE_ASSOC_USER = "Are you sure you want to activate the deleted user "; 

export const LBL_APPROVE_TIMESHEET         = 'Approve Timesheet';  
export const LBL_EDIT_TIMESHEET            = 'Edit Timesheet';  
export const LBL_SHIFT_AND_SKILL           = 'Shift and skill';  
export const LBL_CHECKIN_DATE_TIME         = 'Check-in date and time';  
export const LBL_CHECKOUT_DATE_TIME        = 'Check-out date and time';  
export const LBL_SHIFT_LENGTH_HOURS        = 'Shift length (hours)';  
export const LBL_OVER_TIME_HOURS           = 'Over time hours';  
export const LBL_CHARGE_RATE_PER_HOUR      = 'Charge Rate/hour';  
export const LBL_PAY_RATE_PER_HOUR         = 'Pay Rate/hour';  
export const LBL_OVER_TIME_BONUS           = 'Over Time Bonus';  
export const LBL_PAY_RATE_TOTAL            = 'Pay Rate Total';  
export const LBL_CHARGE_RATE_TOTAL         = 'Charge Rate Total';
export const LBL_OT_CHARGE_RATE_PER_HOUR   = 'OT Charge Rate/hour';  
export const LBL_OT_PAY_RATE_PER_HOUR      = 'OT Pay Rate/hour';
export const LBL_OT_PAY_RATE_TOTAL         = 'OT Pay Rate Total';
export const LBL_OT_CHARGE_RATE_TOTAL      = 'OT Charge Rate Total';  
export const LBL_CLIENT_FEEDBACK           = 'Client Feedback';
export const LBL_CHIEF_FEEDBACK            = '{0} Feedback';

export const LBL_CERTIFICATEMANDATORY      = 'Certificate Mandatory';  
export const LBL_CERTIFICATE_MANDATORY     = 'Certificate Mandatory?';  
export const LBL_CERTIFICATE_NEEDED        = 'Certificate Needed?'; 
export const LBL_CERTIFICATE_DETAILS       = 'Certificate Details';  


export const LBL_BTN_SKILL_DISPLAY_INDEX   = 'Change Skill Display Index';  
export const LBL_SKILL_DISPLAY_INDEX       = 'Drag and drop to change the display index';

export const LBL_AUTO_CHECKOUT_INITIATED   = 'Auto checkout should be initiated after (hh:mm, hours)';

export const LBL_RESET_YOUR_PASSWORD       = 'Reset your password'; 
export const LBL_FORGOT_YOUR_PASSWORD      = "Forgot your password? No worries. Just enter the email you used to sign up and we'll send you a link to reset it."; 
export const LBL_SEND_PASSWORD_RESET_EMAIL = 'Send password reset email'; 

export const LBL_REQUESTS_SEND       = 'Requests sent'; 

export const LBL_SCHEDULE_SHIFT_FIND_CREW  = stringFormat('Select shift(s) to find the matching {0}.',lblCrew); 

export const LBL_UNALLOCATED_SHIFT_TODAY_TOMORROW       = 'Unallocated shifts for today & tomorrow';
export const LBL_UNALLOCATED_SHIFT       = 'Unallocated shifts';
export const LBL_COPY_RATES_TO           = 'Copy the rates of {0} skill to ';

export const LBL_NEW_QUOTE_REQUESTS      = 'New';
export const LBL_EXISTING_QUOTE_REQUESTS = 'Existing';

export const LBL_MULTI_SHIFT             = 'Multi Shift';
export const LBL_ALL_COMMON_SKILLS       = 'All Common Skills';
export const LBL_SHOW_DATE_RANGE         = 'Show Date Range';
export const LBL_DATE_RANGE              = 'Date Range';


export const LBL_SEARCH_CERTIFICATES   = stringFormat('Client/{0} Name, Certificate Name',lblCrew);
export const LBL_FEEDBACK_SEARCH       = 'Shift Name/'+LBL_EVENT+' Name'; // /Client Name
export const LBL_CLIENT_NAME		   = 'Client Name'

export const LBL_DELETED               = 'Deleted';
export const LBL_JOIN_DATE_FROM        = 'Joining Date From';

export const LBL_SUPERVISOR_NAME       = 'Name for the Supervisor';
export const LBL_STAFF_NAME       	   = 'Name for the Staff';
export const LBL_SEL_PAY_LEVEL         = 'Select Pay Level';
export const LBL_PP                    = "PP";
export const LBL_INDUCTION_COMPLETED   = "Induction Completed";
export const LBL_ALTERNATE_NUMBER      = "Alternate number";
export const LBL_GENDER                = "Gender";
export const LBL_MALE                  = "Male";
export const LBL_FEMALE                = "Female";
export const LBL_THIRD_GENDER          = "Third Gender";
export const LBL_PREFER_NOT_TO_SAY     = "Prefer not to say";
export const LBL_DOB                   = "Date of birth";
export const LBL_SELECT_A_DATE         = "Select a Date";
export const LBL_NATIONALITY           = "Nationality";
export const LBL_GET_LOC_FROM_GOOGLE   = "Get location from Google";

export const LBL_INDUCT                = 'Induct';  

export const LBL_CHOOSE_CLIENT         = 'Choose Client';  
export const LBL_CHOOSE_AFFILIATE      = 'Choose Affiliate';  
export const LBL_CONFIRM_DELETE_SKILL  = "This skill has already been used in another module, do you still want to delete this record?";   
export const LBL_IS_CERTIFICATE_MANDATORY = "Is certificate mandatory?";   
export const LBL_CERTIFICATE_NAME      = "Certificate Name"; 
export const LBL_ICON_FONTAWESOME_CLASS= "Skill icon - Font Awesome classname"; 

export const LBL_TODAY_TOMORROW        = "today & tomorrow";   

export const LBL_SHIFT_SUMMARY         = 'Shift Summary'; 
export const LBL_SHIFT_OVERVIEW        = 'Overview';   

export const LBL_TEAM                  = 'Team';   
export const LBL_SELECT_SHIFT          = "Select Shift"; 
export const LBL_PLUS_NEW_QUOTE        = "+ New Quote"; 
export const LBL_SCHED_VIEW_SUB_SEARCH = (LBL_EVENT+'/Shift Name');  
export const LBL_SHIFTS_IN             = 'Shifts in'; 

export const LBL_REJECTED               = 'Rejected'; 
export const LBL_EXPIRED                = "Expired";
export const LBL_CONFIRM_DELETE         = "Confirm Delete";
export const LBL_CONFIRM_UNDO_DELETE    = "Confirm Undo Delete";
export const LBL_CONFIRM_DELETE_DOC  	= "Are you sure you want to delete ";
export const LBL_CONFIRM_DELETE_DOCUMENT= "Are you sure you want to delete document ";
export const LBL_CONFIRM_DELETE_FILE_FROM="Are you sure you want to delete file from ";
export const LBL_CONFIRM_DATA_CHANGE    = "Confirm Data Change";

export const LBL_SHIFT_DETAILS          = 'Shift Details'; 

export const LBL_REVIEWED_BY_CLIENT_ASSOC = 'Reviewed by (Client Associate)'; 

export const LBL_CONFIRM_REJECT_QUOTE       = 'Are you sure you want to reject this quote?'; 
export const LBL_CONFIRM_SEND_QUOTE_REQUEST = 'Are you sure you want to send a quote request to the affiliate?'; 
export const LBL_SEND_QUOTE_REQUEST_NOTE    = 'Please note - These costs are for estimation purposes only and are subject to change.';  

export const LBL_EXPORT 					= "Export";
export const LBL_EXPORT_TO_CSV 				= "Export to CSV";
export const LBL_EXPORT_TO_PDF 				= "Export to PDF";

export const LBL_SEL_CATEGORY    	        = 'Select Category';
export const LBL_SEL_CLIENT_CATEGORY    	= 'Select Client Category';

export const LBL_COPY_RATE_TO_CATEGORY 		= 'Copy the above selected skill rates to';

export const LBL_MESSAGES 					= 'Messages';
export const LBL_SEND 						= 'Send';
export const LBL_CHOOSE_CREW 				= stringFormat('Choose {0} ...',lblCrew);
export const LBL_CHOOSE_LOCATION 			= 'Choose Location ...';

export const LBL_TIME_CHANGE_REQUEST    	        = 'Time change request'; 
export const LBL_TIME_CHANGE_REQUEST_CLIENT         = 'Time change request sent'; 
export const LBL_CONFIRM_SHIFT_TIME_CHANGE_HEAD    	= 'Confirm Shift Time Change '; 
export const LBL_CONFIRM_SHIFT_TIME_CHANGE_ACCEPT   = 'Are you sure you want to accept the shift time change request from the client? '; 
export const LBL_CONFIRM_SHIFT_TIME_CHANGE_REJECT   = 'Are you sure you want to reject the shift time change request from the client? '; 
export const LBL_ACCEPT_SHIFT_TIME_CHANGE_REQUEST   = 'Accept Shift Time Change'; 
export const LBL_REJECT_SHIFT_TIME_CHANGE_REQUEST   = 'Reject Shift Time Change'; 
export const LBL_SHIFT_TIME_CHANGE_REQUESTS    	    = 'Shift Time Change Requests'; 
export const LBL_MESSAGE_TO                         = 'Message to {0}'; 

export const LBL_QUOTE_REQUESTS    	                = 'Quote Requests'; 
export const LBL_WITHIN_30_DAYS    	                = 'Within 30 days'; 
export const LBL_NEGATIVE_FEEDBACK 	                = 'Negative Feedback'; 
export const LBL_LAST_30_DAYS      	                = 'Last 30 days'; 
export const LBL_OVERTIME_REQUESTS 	                = 'Overtime Requests'; 
export const LBL_NO_MESSAGES 	               	 	= 'No messages';

export const LBL_COPY_RATE_CARD                     = 'Copy Rate Card To Client';
export const LBL_COPY_CATEGORY                      = 'Copy Category';

export const LBL_SHIFT_TIME_CHANGE_ACCEPT_REMOVE_CREW = stringFormat('Remove All {0}  and Send New Shift Request',lblCrew);
export const LBL_SHIFT_TIME_CHANGE_ACCEPT_NOTIFY_CREW = 'Send Time Change Push';

export const LBL_NEW_AND_EXISTING                     = 'New & Existing';

export const LBL_OTHER          	= "Other";
export const LBL_OTHER_EXP      	= "Other exp.";
export const LBL_SKILL_PAY      	= "Skill Pay";
export const LBL_CHIEF_BONUS    	= 'Chief Bonus'; 
export const LBL_OT             	= 'OT'; 
export const LBL_DRIVER_PAY_RATE	= 'Driver Rate'; 
export const LBL_PASSENGER_PAY_RATE = 'Passenger Rate'; 
export const LBL_SHIFT_TOTAL_TRAVEL_COST = 'Shift Total Travel Cost';

export const LBL_DELETED_CONFIRM = 'deleted';
export const LBL_GROUP_BY 		= 'Group By';
export const LBL_GROUP_CREW 	= 'Group By {0}';
export const LBL_GROUP_SHIFT 	= 'Group By Shift';
export const LBL_TOTAL_SHIFTS 	= 'Total Shifts';
export const LBL_OK 			= 'OK';
export const LBL_INFO 			= 'Shift time change';

export const LBL_WORKING_HRS    = 'Total hrs';
export const LBL_WORKING_HRS_DESC    = 'Total hours worked in last 30 days';
export const LBL_SORT_BY_CREW    	 = 'Sort By {0}';
export const LBL_SORT_BY_HOURS    	 = 'Sort By Hours';
export const LBL_ASCENDING_ORDER   	 = 'Ascending Order';
export const LBL_DESCENDING_ORDER    = 'Descending Order';

export const LBL_CREW_VISIBILITY     = '{0} Visibility';
export const LBL_CLIENT_VISIBILITY   = 'Client Visibility';
export const LBL_AMOUNT              = 'Amount';
export const LBL_MUTE_EMAILS         = 'Mute all emails';
export const LBL_MUTE_NOTICATIONS    = 'Mute all notifications';
export const LBL_NOT_APPROVED    	 = 'Not Approved';

export const LBL_OT_APPROVED 		= 'OT Approved';
export const LBL_INVOICE_SENT       = 'Invoice Sent?';
export const LBL_OE_DETAILS         = 'OE Details';
export const LBL_VIEW         		= 'View';
export const LBL_VIEW_TIMESHEET     = 'View Timesheet';
export const LBL_CREATED_TIME       = 'Created Time';
export const LBL_CREATED_UPDATED_TIME       = 'Created/Updated Time';
export const LBL_INVOICE_ID       	= 'Inovice #';
export const LBL_SENT_TO_CUSTOMER   = 'Sent to Customer?';
export const LBL_OE_DISCOUNT        = 'Other Expense/Discount';
export const LBL_TYPE        		= 'Type';
export const LBL_REGEN_INVOICE      = 'Preview Invoice';
export const LBL_VOID_INVOICE       = 'Void Invoices';
export const LBL_CREATED_ON         = 'Created On';
export const LBL_VOID_ON            = 'Void On';
export const LBL_REMOVE             = 'Remove';
export const LBL_EXPENSE            = 'Expense';
export const LBL_INVOICE_NUMBER     = 'Invoice Number';
export const LBL_INVOICE_REGENERATED     = 'Invoice regenerated successfully.';
export const LBL_CONFIM_TO_REGEN_INVOICE = 'Regenerate Confirmation';
export const LBL_SEND_UPDATED_INVOICE    = 'Regenerate & Send Invoice';
export const LBL_NOT_GENERATED   		 = 'Not generated';
export const LBL_CN_NO   		 		 = 'Credit Note #';
export const LBL_INV_NO   		 		 = 'Invoice #';
export const LBL_AFFILIATE_VEHICLE_INFO  = 'Affiliate Vehicle Info';
export const LBL_VEHICLE_DETAILS		 = 'Vehicle Details';
export const LBL_VEHICLE_INFO  			 = 'Vehicle Info';
export const LBL_ADD_VEHICLE_FIELDS  	 = 'Add Fields For Vehicle';
export const LBL_ADD_VEHICLE_FIELD  	 = 'Add Vehicle Field';
export const LBL_EDIT_VEHICLE_FIELD  	 = 'Edit Vehicle Field';
export const LBL_VEHICLE_LIST  	         = 'Vehicle List';
export const LBL_AFFILIATE_VEHICLE_LIST  = 'Affiliate Vehicle List';
export const LBL_ADD_VEHICLE  	         = 'Add Vehicle Details';
export const LBL_EDIT_VEHICLE  	         = 'Edit Vehicle Details';
export const LBL_NOT_SELECTED  	         = 'Not Selected';
export const LBL_AFF_VEH_DETAILS  	     = 'Affiliate Vehicle';
export const LBL_CREW_VEH_DETAILS  	     = '{0} Vehicle Details';
export const LBL_OR  	     			 = 'OR';
export const LBL_REMOVE_AFF_VEHICLE  	 = 'Remove Affiliate Vehicle';
export const LBL_REMOVE_CREW_VEHICLE  	 = 'Remove {0} Vehicle';
export const LBL_SELECT_VEHICLE  	     = 'Select {0} Vehicle';
export const LBL_SELECT_All     		 = 'Select all';  
export const LBL_SELECT_All_DEPARTMENTS	 = 'Select all departments';  
export const LBL_EVENT_CANCEL_REASON 	 = 'Quote/'+LBL_EVENT+' Cancel Reason';  
export const LBL_EVENT_CANCEL_REASONS 	 = 'Quote/'+LBL_EVENT+' Cancel Reasons';  
export const LBL_QUOTE_EVENT_CANCEL_REASONS	 = 'Quote/'+LBL_EVENT+' Cancelled Reasons';  

export const LBL_FROM_CLIENT_CATEGORY    = 'From Client Category'; 
export const LBL_TO_CLIENT_CATEGORY      = 'To Client Category';

export const LBL_FROM_CATEGORY    = 'From Category'; 
export const LBL_TO_CATEGORY      = 'To Category'; 

export const LBL_TERMS_AND_CONDITIONS    = 'Terms & Conditions'; 
export const LBL_GROUP   				 = 'Group';
export const LBL_TERMS_SAVE_NEW          = 'Save as new Terms & Conditions'; 
export const LBL_I_ACCEPT          		 = 'Continue'; 
export const LBL_I_ACCEPT_TERMS     	 = 'I accept Terms & Conditions'; 
export const LBL_ACTION_TAKEN 			 = 'Action Taken'; 
export const LBL_REPORTS     	 		 = 'Reports'; 
export const LBL_CREW_AVAILABILITY     	 = stringFormat('{0} Availability',lblCrew); 
export const LBL_CREW_NOT_ACCEPTED     	 = stringFormat('{0} - Not Accepted Shift',lblCrew); 
export const LBL_CREW_AVAIL_SUMMARY_REPORT = stringFormat('{0} - Availability Summary',lblCrew);  

export const LBL_HH_MM     	 			 = 'hh:mm'; 
export const LBL_TIME     	 			 = 'Time'; 

export const LBL_IOS_APP_FOR_STAFF		 = stringFormat('iOS App for {0}',lblCrew);  
export const LBL_ANDROID_APP_FOR_STAFF   = stringFormat('Android App for {0}',lblCrew);   
export const LBL_FOOTER_COPYRIGHT_TEXT   = 'Copyright © '+ ((new Date()).getFullYear()).toString() +' '+LBL_APP_NAME+'. All rights reserved.'; 
export const LBL_FOOTER_BROWSER_TEXT     = "For better view use "; 
export const LBL_FOOTER_BROWSER_NAMES    = " Google Chrome.";
export const LBL_ROLE_PERMISSIONS_SETTINGS={'quotes': 'Quotes Menu',
												'quotessummary': 'Quotes Values/Summary',
												'events': LBL_EVENTS+' Menu',
												'acceptquote': 'Accept Quote',
												'schedule': 'Schedule', 
												'timesheet': 'Timesheet',
												'feedback': 'Feedback',
												'certificates': 'Certificates',
												'settings': 'Settings',
												'companyprofile': 'Company Profile',
												'associateusers': 'Associate Users',
												'client': 'Client',
												'crew': lblCrew,
												'crewunavailability': lblCrew+' Unavailability',
												'assodepartment': "Associate's Dept.",
												'logs': 'Logs',
												'eventlocations': LBL_EVENT+' Locations',
												'keylocations': 'Key Locations',
												'settingsdepartments': 'Department',
												'clientcategories': 'Client Categories',
												'clientdocument': 'Client Document',
												'crewdocuments': lblCrew+' Documents',
												'dynfieldforclient': 'Dynamic Field For Client',
												'dynfieldforcrew': 'Dynamic Field For '+lblCrew,
												'vehicleinfo': 'Vehicle Info',
												'skills': 'Skills',
												'masterratecard': 'Rate Cards',
												'paylevels': 'Pay Levels',
												'otherexpenses': 'Other Expenses',
												'eventcancelreasons': 'Quote/'+LBL_EVENT+' Cancel Reasons',
												'rolesandpermissions': 'Roles & Permissions',
												'csvtemplatesdownload': 'CSV Templates Download',
												'inviteafriend': 'Invite a Friend',
												'affiliate': 'Affiliate',
												'loginas': 'Login As',
												'sector': 'Sectors',
												'subsector': 'Sub Sectors',
												'dynfieldforaffiliate': 'Dynamic Field For Affiliate',
												'performancepoints': 'Performance Points',
												'mnyhandspointsagainstpp': LBL_APP_NAME+' Point Against PP',
												'termsandconditions': 'Terms & Conditions'
											};
export const LBL_CLIENT_PROFILE = {
	'companyName': 'Company name', 
	'website':'Website', 
	'primaryContact':'Primary Contact', 
	'firstName':'First name', 
	'lastName':'Last name', 
	'emailAddress':'Email address', 
	'mobileNumber':'Mobile number', 
	'position':' Position'
}; 		

export const LBL_RATECARD_COPY = 'Copy rates from'; 
export const LBL_SEL_RATECARD = 'Select Rate Card'; 

export const LBL_FILTER_CLIENT_FEEDBACK 	= 'Client Feedback'; 
export const LBL_FILTER_CHIEF_FEEDBACK  	= "{0} Feedback"; 

export const LBL_POST  = 'Post'; 
export const LBL_CONFIRM_DELETE_NOTES_DOCUMENT= "Are you sure you want to delete this document?";

export const LBL_SHIFTS_IN_ESTIMATION       = 'Shifts in Estimation'; 
export const LBL_QUOTE_SENT  				= 'Quote Sent'; 
export const LBL_QUOTE_ACCEPTED   			= 'Quote Accepted'; 

export const LBL_OWN_VEHICLE      			= 'Own vehicle'; 
export const LBL_AFFILIATE_VEHICLE  		= 'Affiliate vehicle '; 
export const LBL_PAY_RATE_TO_ALL_PASSENGERS = 'Pay rate to passengers'; 
export const LBL_PAY_RATE_TO_DRIVER         = 'Pay Rate to Driver';
export const LBL_PAY_RATE_CHARGE_RATE_ERROR = "Pay rate greater than Charge rate, please check";


export const LBL_ADD_CREW_NOTES = "Add Notes"; 
export const LBL_BASIC_CONFIGS   = "Basic Config"; 
export const LBL_BASIC_CONFIGURATIONS   = "Basic Configuration"; 
export const LBL_BACK_TO_BASIC_CONFIGS  = "< Back "; 
export const LBL_BACK_TO_STAFF_LIST  = "<< Staff List "; 
export const LBL_ADD_FIELDS = "Add Fields"; 
export const LBL_BACK_TO_SETTINGS  = "< Back "; 

export const LBL_LOADING = "Loading..."; 

export const LBL_FONTAWESOME_ICON_URL        = "https://fontawesome.com/icons/"; 
export const LBL_FONTAWESOME_ICON_CLASS		 = '<i class="fa-solid fa-video"></i>'; 
export const LBL_FONTAWESOME_ICON_GUIDELINE1 = "Go to "; 
export const LBL_FONTAWESOME_ICON_GUIDELINE2 = "Search for relevent 'Free' icon for this skill"; 
export const LBL_FONTAWESOME_ICON_GUIDELINE3 = "Double click on the icon and copy its HTML code"; 
export const LBL_FONTAWESOME_ICON_GUIDELINE4 = "Add its classname only in the text box provided, without quotes."; 
export const LBL_FONTAWESOME_ICON_GUIDELINE5 = "e.g. If the HTML code is"; 
export const LBL_FONTAWESOME_ICON_GUIDELINE6 = "add only  'fa-solid fa-video' without quotes like given below."; 

export const LBL_DRIVE_TO_SHIFT_LOCATIONS = 'Drive to shift locations';


//ADD NEW CLIENT
export const LBL_PHYSICAL_ADDRESS = "Physical Address"; 
export const LBL_BILLING_ADDRESS = "Billing Address"; 
export const LBL_SAME_AS_PHYSICAL_ADDRESS = "Check here if physical and billing are same address"; 

export const LBL_CLIENT_INFORMATION = "Client Information";
export const LBL_USER_INFORMATION = "User Information";
export const LBL_ADDRESS = "Address";
export const LBL_PHONE_NUMBER = "Phone Number";
export const LBL_REQUEST_BY = "Requested by";

export const LBL_REQUESTS_PENDING 	= "Requests pending"; 
export const LBL_REQUESTS_SENT 		= "Requests sent";
export const LBL_REQUESTS_ACCEPTED 	= "All accepted / No action required";

export const FILE_CSVDOWNLOAD_EVENTS	= LBL_EVENTS+"-list.csv"; 
export const FILE_CSVDOWNLOAD_QUOTES	= LBL_QUOTES+"-list.csv"; 
export const LBL_SELECT_STAFF_DATA_FIELDS = stringFormat('Please select required fields for {0} data PDF export.',lblCrew.toLowerCase());  

